import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { LOGS, DETAILS, NUTRITION_SUMMARY } from 'utils/constants/collectionNames';
import { toDateFormat } from 'utils/helpers/timestampHelper';
import Moment from 'moment'
import { roundNum } from 'utils/numbers';
import {
  GET_NUTRITION_LOGS_SUCCEED,
  GET_NUTRITION_LOGS_ERROR,
  GET_ALL_NUTRITION_LOGS_SUCCEED,
  GET_ALL_NUTRITION_LOGS_ERROR,
  GET_NUTRITION_SUMMARY_SUCCEED,
  GET_NUTRITION_SUMMARY_ERROR,
  TYPE,
  MEAL,
  SNACK,
  DRINK,
  WATER,
  DATE,
  PAGE_SIZE,
  LOADING_STATE,
  LOADING_NUTRITION_LOG_STATE,
  LOADING_ALL_NUTRITION_LOG_STATE
} from './types';

export const getNutritionSummery = (clientId) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = firestore
      .collection(NUTRITION_SUMMARY)
      .doc(clientId)
      dispatch({
        type: LOADING_STATE
      });
  docRef
    .get()
    .then(doc => {
      if (doc.exists) {
        dispatch({
          type: GET_NUTRITION_SUMMARY_SUCCEED,
          payload: {...doc.data()}
        });
        return;
      } else {
        dispatch({
          type: GET_NUTRITION_SUMMARY_SUCCEED,
          payload: {},
        });
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_NUTRITION_SUMMARY_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getNutritionLog = (clientId, newStart, direction) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = '';

  if(direction === 'next') {
    docRef = firestore
      .collection(LOGS)
      .doc(clientId)
      .collection(DETAILS)
      .where(TYPE, "in", [MEAL, SNACK, DRINK, WATER])
      .orderBy(DATE, 'desc')
      .startAfter(newStart || '')
      .limit(PAGE_SIZE);
  } else if( direction === 'previous') {
    docRef = firestore
      .collection(LOGS)
      .doc(clientId)
      .collection(DETAILS)
      .where(TYPE, "in", [MEAL, SNACK, DRINK, WATER])
      .orderBy(DATE, 'desc')
      .startAt(newStart || '')
      .limit(PAGE_SIZE);
  } else {
    docRef = firestore
      .collection(LOGS)
      .doc(clientId)
      .collection(DETAILS)
      .where(TYPE, "in", [MEAL, SNACK, DRINK, WATER])
      .orderBy(DATE, 'desc')
      .limit(PAGE_SIZE);
  }

  dispatch({
    type: LOADING_NUTRITION_LOG_STATE
  });

  docRef
    .get()
    .then(snapshot => {
      if (snapshot.empty) {
        dispatch({
          type: GET_NUTRITION_LOGS_SUCCEED,
          payload: []
        });
        return;
      }
      let nutritionLogs = [];
      let next = snapshot.docs[snapshot.docs.length - 1];
      let previous = snapshot.docs[0];
      snapshot.forEach(doc => {
        nutritionLogs.push(doc.data());
      })
      dispatch({
        type: GET_NUTRITION_LOGS_SUCCEED,
        payload: nutritionLogs,
        next: next,
        previous: previous
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_NUTRITION_LOGS_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getAllNutritionLog = (clientId) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = firestore
      .collection(LOGS)
      .doc(clientId)
      .collection(DETAILS)
      .where(TYPE, "in", [MEAL, SNACK, DRINK, WATER])
      .orderBy(DATE, 'desc')

  dispatch({
    type: LOADING_ALL_NUTRITION_LOG_STATE
  });
  docRef
    .get()
    .then(snapshot => {
      if (snapshot.empty) {
        dispatch({
          type: GET_ALL_NUTRITION_LOGS_SUCCEED,
          payload: []
        });
        return;
      }
      let logs = [];
      snapshot.forEach(doc => {
        logs.push(doc.data());
      })
      dispatch({
        type: GET_ALL_NUTRITION_LOGS_SUCCEED,
        payload: formatLogs(logs),
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_ALL_NUTRITION_LOGS_ERROR,
        payload: `error: ${error}`
      });
    });
};

const formatLogs = (logs) => {
  return logs.map(log => {
    return {
      date: Moment(toDateFormat(log.created_at)).format('DD-MM-YYYY'),
      time: Moment(toDateFormat(log.created_at)).format('LT'),
      type: log.type,
      name: log.name ? log.name : '-',
      servingSize: log.serving_size ? roundNum(log.serving_size) : 1,
      grams: log.total_grams ? roundNum(log.total_grams) : '-',
      calories: log.total_calories ? roundNum(log.total_calories) : '-',
      fats: log.total_fats ? roundNum(log.total_fats) : '-',
      carbs: log.total_carbs ? roundNum(log.total_carbs) : '-',
      protein: log.total_protein ? roundNum(log.total_protein) : '-',
      liters: log.liters ? roundNum(log.liters) : '-',
    }
  })
}

